import React from 'react';
import './LoadingFallback.css';

const LoadingFallback = () => {
  return (
    <div className="page-loading-wrapper" aria-label="Loading page content">
      <div className="page-loading-bar-container">
        <div className="page-loading-bar-inner"></div>
      </div>
    </div>
  );
};

export default LoadingFallback;
